import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04b10ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover-wrapper" }
const _hoisted_2 = { class: "content-box" }
const _hoisted_3 = { class: "tag-wrapper" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "view" }, " VIEW ")
], -1))

import { computed, ref } from 'vue';
  import { StoryItem } from '@/types/story';
  import { isMobile } from '@/utils';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    data: StoryItem;
    tagHeight?: number;
  }

  interface Tag {
    type: 'tag' | 'category';
    name: string
    background_color?: string;
    font_color?: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    data: null,
    tagHeight: null
  },
  setup(__props: any) {

const props = __props as {
    data: StoryItem;
    tagHeight?: number;
  }

  const { locale } = useI18n();
  
  const tagContent = ref<HTMLElement>();
  const mobile = isMobile();
  const tags = computed<Tag[]>(() => {
    const list: Tag[] = [];
    if (props.data.article_category) {
      list.push({
        type: 'category',
        name: props.data.article_category.title,
        background_color: props.data.article_category.background_color || '#eecc3f',
        font_color: props.data.article_category.font_color || '#000',
      });
    }
    if (!mobile && Array.isArray(props.data.tag_list)) {
      props.data.tag_list.forEach((item) => {
        list.push({
          type: 'tag',
          name: item,
        });
      });
    }
    return list;
  });

  const tagContentStyle = computed(() => {
    const style: any = {};
    if (props.tagHeight) {
      style.height = `${props.tagHeight}px`;
    }
    return style;
  });

  const cardTitle = computed(() => {
    return props.data.title && props.data.title?.replace(/\\n|<br>/g, '') || '';
  });

return (_ctx: any,_cache: any) => {
  const _component_AppAutoHeight = _resolveComponent("AppAutoHeight")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'story.detail', params: { slug: __props.data.slug } },
    class: "link"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["story-item", `lang-${_unref(locale)}`])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_AppAutoHeight, {
            height: "100%",
            "image-url": __props.data.cover?.url
          }, null, 8, ["image-url"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "tagContent",
            ref: tagContent,
            class: "tag-content",
            style: _normalizeStyle(_unref(tagContentStyle))
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["tag", { yellow: item.type === 'category', [`lang-${_unref(locale)}`]: true }]),
                  style: _normalizeStyle(item.background_color ? { backgroundColor: item.background_color, color: item.font_color } : {})
                }, " # " + _toDisplayString(item.name), 7))
              }), 128))
            ])
          ], 4),
          _createElementVNode("div", {
            class: "title text-overflow-2",
            innerHTML: _unref(cardTitle)
          }, null, 8, _hoisted_4)
        ]),
        _hoisted_5
      ], 2)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})